// extracted by mini-css-extract-plugin
export default {"container":"Prices_container__G+ykh","form":"Prices_form__AYgh8","field":"Prices_field__eJzYY","saveBtn":"Prices_saveBtn__RWyMX","status":"Prices_status__tnONG"};